export enum AccountSummaryTablesEnum {
    General,
    Margin,
    AccountActivity,
    TodaysResults,
}
